import { render } from "./CxTransparencyControl.vue?vue&type=template&id=23547b4c"
import script from "./CxTransparencyControl.vue?vue&type=script&lang=js"
export * from "./CxTransparencyControl.vue?vue&type=script&lang=js"

import "./CxTransparencyControl.vue?vue&type=style&index=0&id=23547b4c&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__